import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { RadioButton } from "primereact/radiobutton";
import { MAGIC_SQUARE_MAX_OPTIONS } from "../Constants.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The magic square's one dial (ADR 0088 §4): the largest number in a square.
 * Nine is the classic 1 to 9 square. The operator bar is hidden for this
 * format - a square is filled by adding, and no operation is chosen.
 */
export function MagicSquareSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleMaxChange(event) {
        setSettings({ ...settings, MagicSquareMax: Number(event.target.value) });
    }

    return (
        <div className="magicSquareSettingsContainer">
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.largestNumberLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.largestNumberAria')}>
                {MAGIC_SQUARE_MAX_OPTIONS.map((option) => (
                    <div key={option}>
                        <RadioButton
                            inputId={`magicSquareMax-${option}`}
                            value={option}
                            checked={settings.MagicSquareMax === option}
                            onChange={handleMaxChange}
                        />
                        <label htmlFor={`magicSquareMax-${option}`}>{option}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MagicSquareSettings;
